/**
 * iOS zooms a page when a focused form control renders below 16px. Keep phone
 * entry text at 1rem while retaining the denser desktop scale.
 */
export const phoneSafeInputTextClass = 'text-base md:text-sm';

/**
 * The one primary call-to-action treatment (auth, invites, recovery, settings
 * save): ink on paper, soft contact shadow, press feedback. Compose with `cn`
 * for size/radius overrides so every site stays one definition.
 */
export const primaryCtaClass =
  'bg-primary text-primary-foreground hover:bg-primary/92 min-h-11 rounded-xl px-3 text-sm font-semibold ' +
  'shadow-[0_1px_2px_oklch(0_0_0/0.12),inset_0_1px_0_oklch(1_0_0/0.08)] ' +
  'transition-[background-color,box-shadow,transform] duration-200 ease-(--ease-out-quart) ' +
  'active:scale-[0.99] disabled:opacity-50';

/**
 * The one text-entry surface (inputs, textareas, selects): card on paper with a
 * hairline that firms up on hover. Pair with `phoneSafeInputTextClass`.
 */
export const textInputClass =
  'border-border bg-card min-h-11 w-full rounded-xl border px-3.5 ' +
  'shadow-[0_1px_2px_oklch(0_0_0/0.03)] transition-[border-color,box-shadow] duration-200 ' +
  'hover:border-control-border/60';

/**
 * A field or setting label: 13/20 at 500, ink (DESIGN-SPEC §6.2). Settings
 * forms, rows and switches all use it, so a page never mixes label sizes.
 */
export const fieldLabelClass = 'text-ui font-medium';

/** Helper text directly under a label or field: 12/16, muted (DESIGN-SPEC §6.2). */
export const fieldHelpClass = 'text-muted-foreground text-xs';
